import { useState, useCallback } from 'react';
import { graphql, useMutation } from 'react-relay';
import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/urls';

import { type useDeleteDraftMutation } from './__generated__/useDeleteDraftMutation.graphql.ts';

export type DeleteDraftStatus = null | 'success' | 'inflight';

export const useDeleteDraft = (
    draftId: string | undefined | null,
    publicProfileUrl?: string | null
): [handleDeleteDraft: () => void, deleteStatus: DeleteDraftStatus, reset: () => void] => {
    const [deleteStatus, setDeleteStatus] = useState<DeleteDraftStatus>(null);

    const [commitDraftDelete, deleteInFlight] = useMutation<useDeleteDraftMutation>(graphql`
        mutation useDeleteDraftMutation($input: NftDeleteItemDraftInput!) {
            nftDeleteItemDraft(input: $input) {
                __typename
            }
        }
    `);

    const handleDeleteDraft = useCallback(() => {
        if (draftId) {
            commitDraftDelete({
                variables: { input: { nftItemId: draftId } },
                onCompleted: () => {
                    window.history.pushState(
                        '',
                        `NFT Create`,
                        handleLocaleUrl(
                            publicProfileUrl || `/nft-create/`,
                            GLOBAL_CLIENT_ONLY_LOCALE
                        )
                    );
                    setDeleteStatus('success');
                },
            });
        }
    }, [commitDraftDelete, draftId, publicProfileUrl]);

    const reset = useCallback(() => setDeleteStatus(null), []);
    const status = deleteInFlight ? 'inflight' : deleteStatus;

    return [handleDeleteDraft, status, reset];
};
